//import EmailValidator from 'isemail';
//import emailValidation from 'email-validation';

export const isValidEmail = (value) => {
    //return emailValidation.valid(value);
    return new RegExp("^[^@\\s]+@[^@\\s]+\\\.[^@\\s]+$").test(value);  // <- compile problems with all email-validation libs i've tried, so just using this for now.
};


// WEBPACK FOOTER //
// ./src/common/src/util/emailValidation.js